function addresses(state = [], action) {
	switch (action.type) {
		case 'ADDRESS_ADDED':
			return [...state, action.address];
		default:
			return state;
	}
}

export default addresses;


// WEBPACK FOOTER //
// ./src/reducers/addresses.js